<template>
  <section class="video container">
    <h2 class="title-highlight">
      <slot name="title" />
    </h2>
    <div class="row">
      <client-only>
        <div class="video-container offset-1 col col-10" :class="{ container: $store.state.layout === 'desktop' }">
          <VideoPlayer
            v-if="videoJsLoaded"
            slot="player"
            :video-id="videoId"
            class="video-player"
          />
          <button
            v-if="button" class="btn-primary" :class="buttonClass"
            @click="$emit('subscribe')" v-html="button"
          />
        </div>
      </client-only>
    </div>
  </section>
</template>

<script>
import VideoPlayer from '@itbpbg/lms-components/src/components/VideoPlayer';

export default {
  components: {
    VideoPlayer,
  },
  props: {
    videoId: { type: String, default: '', required: true },
    button: { type: String, default: '', required: false },
    buttonClass: { type: String, default: '', required: false },
    videoJsLoaded: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.video {
  padding-bottom: var(--spacing-120);
  // padding: var(--spacing-120) 0;

  .video-player-content {
    border-width: 5px;
    padding-bottom: 54.43%;
  }

  ::v-deep .player.video-player.video-js .vjs-control-bar {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  h2 {
    margin-bottom: var(--spacing-32);
    text-align: center;
    color: var(--main-light);
    max-width: 580px;
    margin-left: auto;
    margin-right: auto;
  }

  .video-js {
    border: 14px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 4px 50px #000916;
    border-radius: 10px;
  }

  @include bp($bp-mobile) {
    position: relative;

    .video-container {
      z-index: 2;
      position: relative;
    }

    .video-js {
      border-radius: 0;
      border: 8px solid rgba(255, 255, 255, 0.08);
    }

    h2 {
      .second-section {
        font-size: 32px;
        top: 4px;

        span {
          top: -5px;
        }
      }
    }
  }

  @include bp($bp-laptop) {
    h2 {
      max-width: 640px;
    }
  }
}
</style>
